import {
  SelectProps,
  VirtualScrollerLazyEvent,
  VirtualScrollerProps,
} from 'primevue';
export enum SelectType {
  MULTIPLE = 'multiple',
  SINGLE = 'single',
  SINGLE_WITH_RADIO = 'single_with_radio',
}

export enum SelectSize {
  SMALL = 'small',
  LARGE = 'large',
}

export enum SelectContent {
  TEXT = 'text',
  CHIPS = 'chips',
  TAGS = 'tags',
}

export type SelectOption<T = object> = {
  label: string;
  value: string;
} & T;

export type SelectVirtualScrollerOptions<T> = Omit<
  VirtualScrollerProps,
  'onLazyLoad'
> & {
  onLazyLoad?(
    event: VirtualScrollerLazyEvent,
    filter: string,
    page: number,
    per_page: number
  ): Promise<{
    items: SelectOption<T>[];
    totalCount: number;
    status: boolean;
  }>;
};

export interface SelectCommonProps<T> {
  options: SelectOption<T>[];
  size?: `${SelectSize}`;
  disabled?: boolean;
  content?: `${SelectContent}`;
  placeholder?: string;
  filteringDisabled?: boolean;
  clearDisabled?: boolean;
  filterFunction?: (filter: string) => SelectOption<T>[];
  asyncFilterFunction?: (filter: string) => Promise<{
    items: SelectOption<T>[];
    totalCount: number;
    status: boolean;
  }>;
  virtualScrollerOptions?: SelectVirtualScrollerOptions<T>;
  appendTo?: SelectProps['appendTo'];
  optionGroupLabel?: string;
  optionGroupChildren?: string;
}
